module.exports = __webpack_public_path__ + "img/dashboardTour4.0be98d53.svg";